import UploadFile from "@mui/icons-material/UploadFile";
import { Button, ButtonProps } from "@mui/material";
import { useQueueManifestDocumentExtraction } from "hooks/useQueueManifestDocumentExtraction";
import { useState } from "react";

import { ManifestUploadDialog } from "./ManifestUploadDialog";

type ExtractManifestButtonProps = {
  tenantId: string;
  facilityId?: string;
  manifestTrackingNumber?: string;
  generatorId?: string;
  /** MUI Button size — defaults to "medium" */
  size?: ButtonProps["size"];
};

/**
 * "Extract Manifest" button that opens the ManifestUploadDialog.
 * Owns its own dialog state. Only renders when the user has permission
 * (staff + ManifestDocumentIngest + DocumentAI flags).
 */
export function ExtractManifestButton({
  tenantId,
  facilityId,
  manifestTrackingNumber,
  generatorId,
  size,
}: ExtractManifestButtonProps) {
  const { canQueueManifestExtraction } = useQueueManifestDocumentExtraction();
  const [open, setOpen] = useState(false);

  if (!canQueueManifestExtraction) return null;

  return (
    <>
      <Button
        variant="outlined"
        color="warning"
        size={size}
        startIcon={<UploadFile />}
        onClick={() => setOpen(true)}
      >
        Extract Manifest
      </Button>

      {open && (
        <ManifestUploadDialog
          open
          onClose={() => setOpen(false)}
          tenantId={tenantId}
          facilityId={facilityId}
          manifestTrackingNumber={manifestTrackingNumber}
          generatorId={generatorId}
        />
      )}
    </>
  );
}
